import { produce } from 'immer';

import { RESET_STATE } from 'store/global/actions';

import { TASK_CATEGORIES_ACTION_TYPE } from '../actions/taskCategories.actions';

const initialState = {};

const taskCategoriesReducer = (state = initialState, { type, payload }) =>
  produce(state, draft => {
    switch (type) {
      case TASK_CATEGORIES_ACTION_TYPE.GET_TASK_CATEGORIES:
        return payload;

      case TASK_CATEGORIES_ACTION_TYPE.DELETE_TASK_CATEGORY:
        delete draft[payload];
        break;

      case TASK_CATEGORIES_ACTION_TYPE.EDIT_TASK_CATEGORY:
      case TASK_CATEGORIES_ACTION_TYPE.ADD_TASK_CATEGORY:
        draft[payload.taskCategoryId] = {
          ...payload,
          isExcluded: !!draft[payload.taskCategoryId]?.isExcluded,
        };

        break;

      case TASK_CATEGORIES_ACTION_TYPE.CHANGE_TASK_CATEGORY_ACTIVITY:
        draft[payload].isExcluded = !draft[payload].isExcluded;
        break;

      case RESET_STATE:
        return initialState;

      default:
        return state;
    }
  });

export default taskCategoriesReducer;
